import React, { useState } from 'react';
import { useRecoilState } from 'recoil';
import { v4 as uuidv4 } from 'uuid';
import { imageUrlsState } from '../recoil';

export default function FileUpload() {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  //   const [isLoading, setIsLoading] = useState(false);
  //   const [error, setError] = useState<string | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [imageUrls, setImageUrls] = useRecoilState(imageUrlsState);

  const handleUpload = async (file: File) => {
    const extension = file.type.split('/')[1];
    console.log(extension);
    const UPLOAD_URL =
      'https://disney-multimodal-video-gateway-no91dcy.uc.gateway.dev/geminiText';
    // create form data to send video blob
    const data = new FormData();
    let imageId = uuidv4();
    const imageUrl = `${imageId}.${extension}`;
    data.append('file', file, imageUrl);
    const response = await fetch(UPLOAD_URL, {
      method: 'POST',
      body: data,
    });
    console.log(response);
    const responseText = await response.text();
    console.log(responseText);
    const gsUrl = `gs://disney-multimodal-ai-content/${imageUrl}`;
    setImageUrls([gsUrl]);
  };

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      setSelectedFile(file);

      // Create a preview URL for the selected image
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = (e) => {
          setPreviewUrl(e.target?.result as string);
        };
        reader.readAsDataURL(file);
        handleUpload(file);
      }
    }
  };

  return (
    <div className="items-top justify-top flex h-[21rem] w-1/2 flex-col rounded-xl border-2 border-gray-400">
      <input
        type="file"
        className="hidden"
        id="file-upload"
        onChange={handleFileChange}
      />
      {previewUrl && (
        <img
          src={previewUrl}
          alt="Preview"
          className="mb-2 h-[80%] w-full rounded-xl object-cover"
        />
      )}
      <label
        htmlFor="file-upload"
        className="cursor-pointer rounded-xl bg-blue-200 px-4 py-2 font-bold text-gray-700 hover:bg-gray-300"
      >
        Choose File
      </label>
    </div>
  );
}
